'use client';

import {
  ArticleCountriesEnum,
  ArticleThemesEnum,
  ArticleTopicsEnum,
  ArticleTypesEnum,
} from '@sola/contentful-model/lib/taxonomy-values.js';
import {
  AdditionalSettingsArticleList,
  ArticleProps,
  BlockProps,
  ComponentBaseProps,
} from '@sola/schema/lib/schema.js';
import { compactObject } from '@sola/utils/object.js';

import {
  ArticleList,
  ArticleListProps,
} from '../../../molecules/article-group/article-list';

export type ArticleListInsertProps = BlockProps &
  ComponentBaseProps & {
    relatedArticle?: ArticleProps;
  };

export const ArticleListInsert: React.FC<ArticleListInsertProps> = ({
  seoLevel,
  settings,
  relatedArticle,
}) => {
  const articleListSettings = settings
    ? AdditionalSettingsArticleList.parse(settings)
    : undefined;

  const listConfig = {
    articleType: articleListSettings?.articleType as
      | ArticleTypesEnum
      | undefined,
    topic: articleListSettings?.topic as ArticleTopicsEnum | undefined,
    country: articleListSettings?.country as ArticleCountriesEnum | undefined,
    theme: articleListSettings?.theme as ArticleThemesEnum | undefined,
    limit: articleListSettings?.limit || 4,
    variant: 'default',
  } as ArticleListProps;

  if (relatedArticle) {
    listConfig.excludeContentfulEntryID = relatedArticle.contentfulEntryID;
    listConfig.articleType =
      relatedArticle.taxonomyArticleType as ArticleTypesEnum;
    listConfig.topic = relatedArticle.taxonomyTopic?.[0] as ArticleTopicsEnum;
    listConfig.country = relatedArticle
      .taxonomyProgramCountry?.[0] as ArticleCountriesEnum;
    listConfig.theme = relatedArticle
      .taxonomyArticleTheme?.[0] as ArticleThemesEnum;
    listConfig.limit = articleListSettings?.limit || 3;
    listConfig.variant = 'related';
  }

  const compactListConfig = compactObject(listConfig);

  return (
    <section className="component component--no-header">
      <div className="container">
        <ArticleList
          seoLevel={seoLevel}
          {...compactListConfig}
          hidePagination
        />
      </div>
    </section>
  );
};
